/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2022-05-23 13:56:12
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */


import { RouterConfig } from 'src/router/types';
import {lazy} from 'react';

const LogQueryRouterCOnfig: RouterConfig[] = [
    {
        key: 'Log Query',
        title: 'menuTitleLogQuery',
        icon: 'LogMenuSVG',
        subs: [
            {
                key: 'Operation Log Query',
                route: '/home/logQuery/optLogQuery',
                title: 'menuTitleOptLogQuery',
                component: lazy(() => import('src/pages/logQuery/optLogQuery')),
            },
            {
                key: 'Login log',
                route: '/home/logQuery/loginLog',
                title: 'menuTitleLoginLog',
                component: lazy(() => import('src/pages/logQuery/loginLog')),
            },
        ],
    },
];

export default LogQueryRouterCOnfig;
